
export const setBaseColor=(color)=>{
    navbarProps.baseColor=color;
}

export const navbarProps={
    baseColor:"#fd576c"
};